import { District, Ward } from "../models/index";

export class HubRoutingWardViewModel {
    id:number;
    hubId:number;
    wardId:number;
    wardName:string;
    districtId:number;
    districtName:string;
    provinceId:number;
    provinceName:string;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/view-model/hubRoutingWard.viewModel.ts